import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import { OnboardingStepProps } from '../../../types/onboarding';
import { PersonaSelection } from '../../registration';
import { AVAILABLE_PERSONAS } from '../../../utils/personaUtils';

const AssessmentContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

const IntroSection = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  padding: 0 1.5rem;
  
  h2 {
    font-size: 2.5rem;
    color: ${theme.colors.text.primary};
    margin-bottom: 1rem;
    background: ${theme.colors.gradients.primary};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  
  p {
    color: ${theme.colors.text.secondary};
    font-size: 1.15rem;
    max-width: 600px;
    margin: 0 auto;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    h2 { font-size: 1.8rem; }
    p { font-size: 1rem; }
  }
`;

export const AssessmentStep: React.FC<OnboardingStepProps> = ({
    data,
    onChange,
    onNext,
    onSkip
}) => {
    const [selectedPersonaId, setSelectedPersonaId] = useState<string | null>(data?.selectedPersona ?? null);

    const handlePersonaSelect = useCallback((id: string) => {
        setSelectedPersonaId(id);
        const persona = AVAILABLE_PERSONAS.find(p => p.id === id);
        if (!persona) return;

        // Save selection. Mark as VALID (true) immediately because the *selection* step is done.
        // The *confirmation* is now the next step.
        onChange({
            ...data,
            selectedPersona: id,
            personaTraits: persona.traits
        }, true);
    }, [data, onChange]);

    return (
        <AssessmentContainer>
            <IntroSection>
                <h2>Choose Your Heart Persona</h2>
                <p>Select the persona that best describes your approach to dating and connection.</p>
            </IntroSection>
            <PersonaSelection
                personas={AVAILABLE_PERSONAS}
                selectedPersona={selectedPersonaId || ''}
                onPersonaSelect={handlePersonaSelect}
                onNext={onNext}
                onSkip={onSkip || (() => { })}
                hideNavigation={true}
            />
        </AssessmentContainer>
    );
};
